/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement
} from '@chakra-ui/core';

/**
 * Dependências internas
 */
import getInformacoesDoCampo from 'utils/form/getInformacoesDoCampo';
import CarregandoInput from 'apresentacao/form/CarregandoInput';

const Localidade = props => {
  const { formik, isLoading, isDisabled, cobranca, ...rest } = props;

  const nomeDoCampo = cobranca ? 'localidadeCobranca' : 'localidade';
  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={possuiErroDeValidacao}
      {...rest}
    >
      <FormLabel htmlFor={nomeDoCampo}>Localidade</FormLabel>
      <InputGroup>
        <Input
          type="text"
          id={nomeDoCampo}
          name={nomeDoCampo}
          onChange={handleChange}
          onBlur={handleBlur}
          value={valor}
          isDisabled={isLoading || isDisabled}
        />

        <InputRightElement>
          {isLoading && <CarregandoInput />}
        </InputRightElement>
      </InputGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Localidade);
